import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Flag, Users, Globe } from 'lucide-react';
interface InvestorSlide8Props {
  isDark?: boolean;
}
export function InvestorSlide8({
  isDark = false
}: InvestorSlide8Props) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  const roadmap = [{
    year: '2025-2026',
    title: 'Leadership Focus',
    desc: 'Executive and management leadership (Current)',
    icon: Flag,
    color: 'orange'
  }, {
    year: '2027',
    title: 'Heliona Teams™',
    desc: 'Expansion to team members and direct reports',
    icon: Users,
    color: 'mint'
  }, {
    year: '2028+',
    title: 'Enterprise Scale',
    desc: 'Organization-wide leadership health infrastructure',
    icon: Globe,
    color: 'navy'
  }];
  return <motion.div className="h-full w-full overflow-y-auto overflow-x-hidden" variants={containerVariants} initial="hidden" animate="visible" data-id="element-381">
      <div className="min-h-full flex flex-col justify-center max-w-6xl mx-auto px-6 sm:px-12 py-20 sm:py-24" data-id="element-382">
        <motion.div variants={itemVariants} className="mb-12 sm:mb-16 text-center" data-id="element-383">
          <h1 className={`text-3xl sm:text-5xl font-bold mb-6 sm:mb-8 tracking-tight ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-384">
            Growth Strategy
          </h1>
          <p className={`text-lg sm:text-2xl max-w-3xl mx-auto ${isDark ? 'text-white/80' : 'text-heliona-text-gray'}`} data-id="element-385">
            From specialized leadership tool to organizational infrastructure.
          </p>
        </motion.div>

        <div className="relative" data-id="element-386">
          {/* Connecting Line (Desktop) */}
          <div className={`hidden md:block absolute left-[16%] right-[16%] top-10 h-1 rounded-full ${isDark ? 'bg-white/10' : 'bg-heliona-beige'}`} data-id="element-387" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-12 relative z-10" data-id="element-388">
            {roadmap.map((step, idx) => {
            const Icon = step.icon;
            return <motion.div key={idx} variants={itemVariants} className={`rounded-3xl p-8 sm:p-10 flex flex-col items-center text-center ${isDark ? 'bg-white/[0.03] border border-white/10' : 'bg-white border border-heliona-beige shadow-sm'}`} data-id="element-389">
                  <div className={`w-20 h-20 rounded-full flex items-center justify-center mb-6 border-4 ${isDark ? 'bg-heliona-navy border-white/10' : 'bg-white border-heliona-cream shadow-sm'}`} data-id="element-390">
                    <Icon className={`w-8 h-8 ${isDark ? 'text-white' : `text-heliona-${step.color === 'mint' ? 'mint-dark' : step.color}`}`} data-id="element-391" />
                  </div>
                  <div className={`text-sm font-bold uppercase tracking-wider mb-2 ${isDark ? 'text-heliona-mint' : 'text-heliona-mint-dark'}`} data-id="element-392">
                    {step.year}
                  </div>
                  <h3 className={`text-2xl font-bold mb-3 ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-393">
                    {step.title}
                  </h3>
                  <p className={`text-base leading-relaxed ${isDark ? 'text-white/70' : 'text-heliona-text-gray'}`} data-id="element-394">
                    {step.desc}
                  </p>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </motion.div>;
}